import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import login from './modules/login';
import personal from './modules/personal';
import ifHeaderFooter from './modules/noHeaderFooter';
import changeMeta from './modules/changeMeta';
import activation from './modules/activation';
import spring26 from './modules/26spring';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    personal,
    ifHeaderFooter,
    changeMeta,
    activation,
    spring26
  },
  getters
});